import { render, staticRenderFns } from "./aboutoursmessage.vue?vue&type=template&id=2b79390c&scoped=true&"
import script from "./aboutoursmessage.vue?vue&type=script&lang=js&"
export * from "./aboutoursmessage.vue?vue&type=script&lang=js&"
import style0 from "./aboutoursmessage.vue?vue&type=style&index=0&id=2b79390c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79390c",
  null
  
)

export default component.exports